import React, { useState, useEffect } from 'react';
import { getSystemLogs } from '../../services/adminApi';
import { notify } from '../../utils/notify';
import './SystemLogs.css';

function SystemLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(50);
  const [total, setTotal] = useState(0);
  const [filters, setFilters] = useState({
    action: '',
    adminId: ''
  });

  useEffect(() => {
    loadLogs();
  }, [page, filters]);

  const loadLogs = async () => {
    try {
      setLoading(true);
      const response = await getSystemLogs(
        page,
        pageSize,
        filters.action || null,
        filters.adminId ? parseInt(filters.adminId) : null
      );
      setLogs(response.data.logs || []);
      setTotal(response.data.total || 0);
    } catch (err) {
      console.error('Failed to load logs:', err);
      const errorMessage = err.response?.data?.detail || err.message || 'Failed to load system logs';
      notify.error(`Failed to load system logs: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString();
  };

  const handleFilterChange = (field, value) => {
    setFilters({ ...filters, [field]: value });
    setPage(1); // Reset to first page when filter changes
  };

  const totalPages = Math.ceil(total / pageSize);

  return (
    <div className="system-logs">
      <div className="logs-header">
        <h2>System Logs</h2>
        <div className="logs-filters">
          <input
            type="text"
            placeholder="Filter by action..."
            value={filters.action}
            onChange={(e) => handleFilterChange('action', e.target.value)}
            className="filter-input"
          />
          <input
            type="number"
            placeholder="Filter by admin ID..."
            value={filters.adminId}
            onChange={(e) => handleFilterChange('adminId', e.target.value)}
            className="filter-input"
          />
        </div>
      </div>

      {loading ? (
        <div className="logs-loading">Loading logs...</div>
      ) : (
        <>
          <div className="logs-info">
            <span>Total: {total} logs</span>
            <span>Page {page} of {totalPages}</span>
          </div>

          <div className="logs-table-container">
            <table className="logs-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Timestamp</th>
                  <th>Admin</th>
                  <th>Action</th>
                  <th>Target Type</th>
                  <th>Target ID</th>
                  <th>IP Address</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {logs.length > 0 ? (
                  logs.map((log) => (
                    <tr key={log.id}>
                      <td>{log.id}</td>
                      <td>{formatDate(log.created_at)}</td>
                      <td>
                        {log.admin_email || `Admin #${log.admin_id}`}
                      </td>
                      <td>
                        <span className="action-badge">{log.action}</span>
                      </td>
                      <td>{log.target_type || '-'}</td>
                      <td>{log.target_id || '-'}</td>
                      <td>{log.ip_address || '-'}</td>
                      <td>
                        {log.details ? (
                          <details className="details-dropdown">
                            <summary>View Details</summary>
                            <pre>{JSON.stringify(log.details, null, 2)}</pre>
                          </details>
                        ) : (
                          '-'
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="no-logs">
                      No logs found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="logs-pagination">
            <button
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              Previous
            </button>
            <span>Page {page} of {totalPages}</span>
            <button
              disabled={page >= totalPages}
              onClick={() => setPage(page + 1)}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default SystemLogs;

